import { render, staticRenderFns } from "./ModalNewVersion.vue?vue&type=template&id=5cdc7c2e&scoped=true&"
import script from "./ModalNewVersion.vue?vue&type=script&lang=js&"
export * from "./ModalNewVersion.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewVersion.vue?vue&type=style&index=0&id=5cdc7c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdc7c2e",
  null
  
)

export default component.exports